<template>
  <div id="per_center">
    <!-- 深色舞台头图横幅（静态装饰，匹配 youxuan-content.html .cbanner） -->
    <section class="cbanner">
      <div class="bg"></div>
      <div class="grid-lines"></div>
      <div class="eyebrow">ABOUT US</div>
      <h1>关于<em>我们</em></h1>
      <div class="en">Company · Advantage · Partner · Recruit</div>
      <span class="gno">YX</span>
    </section>
    <div class="center_body">
    <div class="nav_menu">
      <div class="nav_menu_title">
        <div class="nav_menu_title_img">
          <img src="@/assets/image/About/aboutLogo.png" alt="">
        </div>
        <div class="nav_menu_title_text">关于我们</div>
        <div><i class="el-icon-arrow-down"></i></div>
      </div>
      <div class="nav_menu_content">
        <el-menu
            router
            :default-active="defaultActive"
            :unique-opened="true"
            class="nav_menu-list"
            @select="handleSelect"
            @open="handleOpen"
            @close="handleClose">
          <!-- 交易流程 -->
          <el-menu-item v-for="item in menu" :key="item.id" :index="item.id.toString()"
              :route="{name:'About',query:{id:item.id,parent_id:item.parent_id}}">
            <span slot="title">{{ item.page_name }}</span>
            <div></div>
          </el-menu-item>
          <!-- 交易须知 -->
          <el-submenu v-for="item in submenu" :key="item.id" :index="item.id.toString()">
            <template slot="title">
              <span> {{ item.page_name }}</span>
              <div></div>
            </template>
            <el-menu-item :index="childItem.id.toString()" v-for="childItem in item._child" :key="childItem.id"
                :route="{name:'About',query:{id:childItem.id,parent_id:item.parent_id}}">
              <div></div>
              {{ childItem.page_name }}
            </el-menu-item>
          </el-submenu>

        </el-menu>
      </div>
    </div>
    <div class="main">
      <!--   游严选优势   -->
      <company v-if="ref == 103"></company>
      <Recruit v-else-if="ref == 120"></Recruit>
      <Content :key1='ref' v-else></Content>
      <!--      <router-view></router-view>-->
    </div>
    </div>
  </div>

</template>

<script>
import Content from './content'
import {apiNavPage} from "@/request/API";
import Company from "./company";
import Recruit from "./recruit";

export default {
  name: '',
  props: {},
  components: {
    Company,
    Content,
    Recruit
  },
  data() {
    return {
      ref: this.$route.query.id.toString(),
      parent_id: this.$route.query.parent_id,
      menu: [],
      submenu: []
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.ref = key.toString()
    },

    handleOpen(key, keyPath) {

    },
    handleClose(key, keyPath) {
    },
    getNavPage() {
      apiNavPage({
        id: this.$route.query.parent_id
      }).then(res => {
        res.data.forEach((item, index) => {
          if ('_child' in item) {
            this.submenu.push(item)
          } else {
            this.menu.push(item)
          }
        })
      })
    }
  },
  mounted() {
    this.getNavPage()
  },
  watch: {},
  computed: {
    defaultActive() {
      this.submenu.forEach((item, index) => {
        if (this.$route.query.id == item.id) {
          return item._child[0].id.toString()
        }
      })
      return this.$route.query.id.toString()
    }
  },
  created() {
  },
  beforeRouteUpdate(to, from, next) {
    this.ref = to.query.id.toString()
    next()
  }
}
</script>

<style lang='less' scoped>
#per_center {
  --about-page-min-height: max(644px, calc(100vh - 430px));

  width: 1200px;
  min-height: var(--about-page-min-height);
  margin: 14px auto 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: var(--bg-page, #F7F5F2);
  border-radius: 4px;

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  /* 深色舞台头图横幅 */
  .cbanner {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    background: var(--bg-stage, #0E1116);
    padding: 38px 40px;
    margin-bottom: 18px;

    .bg {
      position: absolute;
      inset: 0;
      background:
        radial-gradient(120% 90% at 82% 8%, rgba(255, 90, 31, .20), transparent 55%),
        linear-gradient(115deg, #171b22 0%, #0e1116 60%, #1d1410 100%);
    }

    .grid-lines {
      position: absolute;
      inset: 0;
      background-image:
        linear-gradient(rgba(255, 255, 255, .03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, .03) 1px, transparent 1px);
      background-size: 40px 40px;
      mask-image: linear-gradient(180deg, transparent, #000 70%);
      -webkit-mask-image: linear-gradient(180deg, transparent, #000 70%);
    }

    .eyebrow {
      position: relative;
      font-size: 11px;
      letter-spacing: 2px;
      color: var(--primary, #FF5A1F);
      font-weight: 700;
      margin-bottom: 10px;
    }

    h1 {
      position: relative;
      color: #fff;
      font-size: 32px;
      font-weight: 900;
      letter-spacing: -1px;
      line-height: 1.1;
      margin: 0;

      em {
        font-style: normal;
        color: var(--primary, #FF5A1F);
      }
    }

    .en {
      position: relative;
      color: #8b919c;
      font-size: 13px;
      margin-top: 10px;
      letter-spacing: 1px;
    }

    .gno {
      position: absolute;
      right: 26px;
      bottom: -22px;
      font-style: italic;
      font-weight: 900;
      font-size: 120px;
      color: rgba(255, 255, 255, .05);
      line-height: 1;
    }
  }

  /* 两栏正文区 */
  .center_body {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
  }

  .nav_menu {
    width: 243px;
    flex: 0 0 243px;
    position: sticky;
    top: 14px;
    align-self: flex-start;
    margin-right: 0;
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;

    .nav_menu_title {
      height: 72px;
      background: var(--bg-dark, #1A1D24);
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 18px 0 28px;

      .nav_menu_title_img {
        width: 37px;
        height: 33px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .nav_menu_title_text {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        margin-right: auto;
      }

      .el-icon-arrow-down {
        color: rgba(255, 255, 255, 0.88);
      }
    }

    .nav_menu_content {
      padding: 11px 0 15px 0;
      //padding-top: 11px;
      min-height: calc(var(--about-page-min-height) - 98px);
      background: var(--bg-card, #FFFFFF);

      .nav_menu-list > .el-menu-item {
        height: 40px;
        line-height: 40px;
        padding-left: 59px !important;
        position: relative;
        overflow: hidden;
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);

        div {
          display: inline-block;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: var(--border-strong, #CBD5E1);
          position: absolute;
          top: 17px;
          left: 30px;
        }
      }

      .nav_menu-list > .is-active {
        color: #FFFFFF !important;
        background: var(--bg-dark, #1A1D24);
        transform: skewX(-12deg);

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 7px;
          height: 7px;
          background: var(--primary, #FF5A1F);
          clip-path: polygon(0 0, 100% 0, 0 100%);
        }

        span {
          display: inline-block;
          transform: skewX(12deg);
        }

        div {
          background: var(--primary, #FF5A1F);
          transform: skewX(12deg);
        }
      }

      .nav_menu-list > .el-menu-item:hover {
        color: var(--text-main, #1A1D24) !important;
        background: var(--bg-tag, #F0EDE8);

        div {
          background: var(--primary, #FF5A1F);
        }
      }

      .nav_menu-list > .is-active:hover {
        color: #FFFFFF !important;
        background: var(--bg-dark, #1A1D24);

        div {
          background: var(--primary, #FF5A1F);
        }
      }

      /deep/ .el-menu-item, /deep/ .el-submenu__title {
        height: 40px;
        line-height: 40px;
        padding-left: 59px !important;
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/ .is-active > .el-submenu__title {
        color: var(--text-main, #1A1D24) !important;
        background: var(--bg-tag, #F0EDE8);

        div {
          background: var(--primary, #FF5A1F) !important;
        }
      }

      /deep/ .el-submenu__title:hover, .el-submenu__title:focus {
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);

        div {
          background: var(--primary, #FF5A1F) !important;
        }
      }

      /deep/ .el-submenu > .el-submenu__title {
        div {
          display: inline-block;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: var(--border-strong, #CBD5E1);
          position: absolute;
          top: 17px;
          left: 30px;
        }
      }

      /deep/ .el-menu--inline {
        background: var(--bg-section, #F7F5F2);
      }

      /deep/ .el-menu--inline > .el-menu-item {
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: var(--text-muted, #9AA0AC);
      }

      /deep/ .el-menu--inline > .el-menu-item:hover {
        background: var(--bg-tag, #F0EDE8);
        color: var(--text-main, #1A1D24);
        position: relative;

        div {
          position: absolute;
          width: 2px;
          height: 16px;
          background: var(--primary, #FF5A1F);
          border-radius: 1px;
          top: 12px;
          left: 35px;
        }
      }

      /deep/ .el-submenu > .el-menu--inline > .is-active {
        background: var(--bg-dark, #1A1D24);
        color: #FFFFFF !important;
        position: relative;
        overflow: hidden;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 7px;
          height: 7px;
          background: var(--primary, #FF5A1F);
          clip-path: polygon(0 0, 100% 0, 0 100%);
        }

        div {
          position: absolute;
          width: 2px;
          height: 16px;
          background: var(--primary, #FF5A1F);
          border-radius: 1px;
          top: 12px;
          left: 35px;
        }
      }

      /*菜单关闭*/

      /deep/ .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
        -webkit-transform: rotateZ(-90deg);
        -ms-transform: rotate(-90deg);
        transform: rotateZ(-90deg);
      }

      /*菜单展开*/

      /deep/ .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
        -webkit-transform: rotateZ(0deg);
        -ms-transform: rotate(0deg);
        transform: rotateZ(0deg);
      }
    }
  }

  .main {
    width: 945px;
    min-height: var(--about-page-min-height);
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;
  }
}
</style>
